<div class="login-container">
  <div class="login-card">

    <!-- Logo -->
    <div class="logo-section">
      <img src="assets/befret_logo.png" alt="BeFret" class="logo-img">
      <p class="brand-subtitle">V&eacute;rification en deux &eacute;tapes</p>
    </div>

    <!-- Icon -->
    <div class="tfa-icon">
      <i class="fas fa-shield-alt"></i>
    </div>

    <p class="tfa-description" *ngIf="!useBackupCode">
      Entrez le code &agrave; 6 chiffres g&eacute;n&eacute;r&eacute; par votre application d'authentification
      (Google Authenticator, Authy, etc.)
    </p>
    <p class="tfa-description" *ngIf="useBackupCode">
      Entrez l'un de vos codes de secours (8 caract&egrave;res)
    </p>

    <!-- Error -->
    <div *ngIf="errorMessage" class="alert alert-error">
      <i class="fas fa-exclamation-circle"></i> {{ errorMessage }}
    </div>

    <!-- Code input -->
    <div class="form-group">
      <label class="form-label">{{ useBackupCode ? 'Code de secours' : 'Code de v\u00e9rification' }}</label>
      <div class="input-wrapper">
        <i class="fas" [ngClass]="useBackupCode ? 'fa-key' : 'fa-lock'" class="input-icon"></i>
        <input [type]="useBackupCode ? 'text' : 'tel'"
               [(ngModel)]="code"
               class="form-control code-input"
               [placeholder]="useBackupCode ? 'Ex: A1B2C3D4' : '000000'"
               [maxlength]="useBackupCode ? 8 : 6"
               autocomplete="one-time-code"
               (keyup.enter)="onVerify()">
      </div>
    </div>

    <!-- Submit -->
    <button class="btn btn-login" [disabled]="loading || !code.trim()" (click)="onVerify()">
      <i class="fas fa-spinner fa-spin" *ngIf="loading"></i>
      <i class="fas fa-check-circle" *ngIf="!loading"></i>
      {{ loading ? 'V\u00e9rification...' : 'V\u00e9rifier' }}
    </button>

    <!-- Toggle backup code -->
    <button class="toggle-link" (click)="toggleBackupCode()">
      <i class="fas" [ngClass]="useBackupCode ? 'fa-mobile-alt' : 'fa-key'"></i>
      {{ useBackupCode ? 'Utiliser le code de l\'application' : 'Utiliser un code de secours' }}
    </button>

    <!-- Back -->
    <button class="back-link" (click)="goBack()">
      <i class="fas fa-arrow-left"></i> Retour &agrave; la connexion
    </button>

  </div>
</div>
